import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import ReactPortal from "../../../../components/Common/ReactPortal";
import { CollapsableHeader } from "./CollapsableHeader";
export function StickyHeader({ item, direction, scrollContainer, open, headerRef, contentRef, childrenCount, onClick, isSticky, setSticky, hideBalances, }) {
    useEffect(() => {
        if (!open) {
            setSticky(false);
            return;
        }
        const onScroll = () => {
            if (!headerRef.current || !contentRef.current || !scrollContainer)
                return;
            const headerRect = headerRef.current.getBoundingClientRect();
            const contentRect = contentRef.current.getBoundingClientRect();
            const containerRect = scrollContainer.getBoundingClientRect();
            const passedTop = headerRect.top - 3 <= containerRect.top;
            const contentGone = contentRect.bottom <=
                containerRect.top + headerRect.height * 1.5;
            setSticky(passedTop && !contentGone && Boolean(childrenCount && childrenCount > 1));
        };
        scrollContainer?.addEventListener("scroll", onScroll, { passive: true });
        return () => scrollContainer?.removeEventListener("scroll", onScroll);
    }, [scrollContainer, open, headerRef, contentRef, childrenCount]);
    if (!isSticky)
        return null;
    return (_jsx(ReactPortal, { wrapperId: "sticky_accordion_header", children: _jsx("div", { onClick: onClick, className: "cursor-pointer bg-secondary-700 hover:bg-secondary-600 relative pb-1", children: _jsx(CollapsableHeader, { item: item, direction: direction, hideTokenImages: open, hideBalances: hideBalances }) }) }));
}
